import { useTranslation } from '../i18n';
import type { MirrorSummary } from '../api/types';

// Visual variant → tone classes + i18n message key.
const PALETTE = {
    Ready: { bg: 'bg-state-ready/15', ring: 'ring-state-ready/40', text: 'text-state-ready', messageKey: 'mirror.ready' },
    Stale: { bg: 'bg-state-stale/15', ring: 'ring-state-stale/40', text: 'text-state-stale', messageKey: 'mirror.stale' },
    Pending: { bg: 'bg-state-pending/15', ring: 'ring-state-pending/40', text: 'text-state-pending', messageKey: 'mirror.pending' },
    Failed: { bg: 'bg-state-failed/15', ring: 'ring-state-failed/40', text: 'text-state-failed', messageKey: 'mirror.failed' },
} as const;

export function MirrorStateBadge({ summary }: { summary?: MirrorSummary | null }) {
    const t = useTranslation();
    if (!summary) return null;
    const variant: keyof typeof PALETTE =
        summary.state === 'Ready' && summary.isStale
            ? 'Stale'
            : summary.state === 'Ready'
              ? 'Ready'
              : summary.state === 'Pending'
                ? 'Pending'
                : 'Failed';
    if (variant === 'Ready') return null;
    const c = PALETTE[variant];
    return (
        <span
            class={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset ${c.bg} ${c.ring} ${c.text}`}
        >
            <span class={`h-1.5 w-1.5 rounded-full ${c.text} bg-current`} />
            {t(c.messageKey)}
        </span>
    );
}
